exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wl-m-select[data-v-620adc9d] {\n  width: 100%;\n}", ""]);

// exports
